<template>
	<div>
		<fieldset class="inline">
			<h3>Arrivée et Départ</h3>

			<b-form-group
				label="Check in à partir de"
				label-for="check_in_time_from"
				description=""
				class="datetime-picker"
			>
				<vue-timepicker
					v-model="conditions.check_in_time_from"
					id="check_in_time_from"
					@input="
						$emit('update:conditions.check_in_time_from', $event)
					"
				></vue-timepicker>
			</b-form-group>

			<b-form-group
				label="Mettre une heure limite de check in"
				label-for="check_in_time_limit"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.check_in_time_limit"
					id="check_in_time_limit"
					@input="
						$emit('update:conditions.check_in_time_limit', $event)
					"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				v-if="conditions.check_in_time_limit"
				label="Arrivée jusqu'à"
				label-for="check_in_time_to"
				description=""
				class="datetime-picker"
			>
				<vue-timepicker
					v-model="conditions.check_in_time_to"
					id="check_in_time_to"
					@input="$emit('update:conditions.check_in_time_to', $event)"
				></vue-timepicker>
			</b-form-group>

			<b-form-group
				v-if="conditions.check_out_time_to"
				label="Check out se fait avant"
				label-for="check_out_time_to"
				description=""
				class="datetime-picker"
			>
				<vue-timepicker
					v-model="conditions.check_out_time_to"
					id="check_out_time_to"
					@input="
						$emit('update:conditions.check_out_time_to', $event)
					"
				></vue-timepicker>
			</b-form-group>

			<b-form-group
				label="Informations supplémentaires pour le check in et check out"
				label-for="checkinExtraConditions"
				description=""
			>
				<b-form-textarea
					v-model="conditions.checkinExtraConditions"
					@input="
						$emit(
							'update:conditions.checkinExtraConditions',
							$event
						)
					"
					id="checkinExtraConditions"
					required
				>
				</b-form-textarea>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>Réception</h3>

			<b-form-group
				label="Réception automatique (borne)"
				label-for="has_automatic_reception"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.has_automatic_reception"
					@input="
						$emit(
							'update:conditions.has_automatic_reception',
							$event
						)
					"
					id="has_automatic_reception"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Réception 24/24"
				label-for="has_twenty_four_hour_reception"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.has_twenty_four_hour_reception"
					@input="
						$emit(
							'update:conditions.has_twenty_four_hour_reception',
							$event
						)
					"
					id="has_twenty_four_hour_reception"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Informations supplémentaires pour la réception"
				label-for="reception"
				description=""
			>
				<b-form-textarea
					v-model="conditions.reception"
					@input="$emit('update:conditions.reception', $event)"
					id="reception"
					required
				>
				</b-form-textarea>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>Conditions générales d'annulation</h3>

			<!-- <b-form-group label="Annulation sans frais"
                label-for="free_cancellation"
                description="">

                <b-form-checkbox v-model="conditions.free_cancellation"
                    @input="$emit('update:conditions.free_cancellation', $event)"
                    id="free_cancellation"
                    name="check-button"
                    size="lg"
                    switch>
                </b-form-checkbox>

            </b-form-group> -->

			<b-form-group
				label="Annulation sans frais, si la réservation est annulée N jours à l'avance"
				label-for="free_cancellation_days_before"
				description=""
			>
				<b-form-input
					type="number"
					min="0"
					v-model="conditions.free_cancellation_days_before"
					@input="
						$emit(
							'update:conditions.free_cancellation_days_before',
							$event
						)
					"
					id="free_cancellation_days_before"
					required
				>
				</b-form-input>
			</b-form-group>

			<b-form-group
				label="L'annulation doit se faire avant"
				label-for="free_cancellation_time"
				description=""
				class="datetime-picker"
			>
				<vue-timepicker
					v-model="conditions.free_cancellation_time"
					id="free_cancellation_time"
					@input="
						$emit(
							'update:conditions.free_cancellation_time',
							$event
						)
					"
				></vue-timepicker>
			</b-form-group>

			<p>
				<strong
					><i
						>En cas d'annulation après la limite, ou de non
						présentation :</i
					></strong
				>
			</p>

			<b-form-group
				label="La première nuitée sera facturée"
				label-for="first_night_billed"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.first_night_billed"
					@input="
						$emit('update:conditions.first_night_billed', $event)
					"
					id="first_night_billed"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>
			<p v-show="!conditions.first_night_billed">
				<strong><i>Ou</i></strong>
			</p>
			<b-form-group
				label="Un pourcentage de la réservation sera facturé"
				v-show="!conditions.first_night_billed"
				label-for="cancellation_charge"
				description=""
			>
				<b-form-select
					v-model="conditions.cancellation_charge"
					@input="
						$emit('update:conditions.cancellation_charge', $event)
					"
					id="cancellation_charge"
				>
					<template v-slot:first>
						<option :value="null" selected disabled
							>-- Merci de choisir un pourcentage --</option
						>
					</template>

					<option value="10">10</option>
					<option value="20">20</option>
					<option value="30">30</option>
					<option value="40">40</option>
					<option value="50">50</option>
					<option value="60">60</option>
					<option value="70">70</option>
					<option value="80">80</option>
					<option value="90">90</option>
					<option value="100">100</option>
				</b-form-select>
			</b-form-group>

			<b-form-group
				label="Conditions supplémentaires pour l'annulation"
				label-for="cancellationConditions"
				description=""
			>
				<b-form-textarea
					v-model="conditions.cancellationConditions"
					@input="
						$emit(
							'update:conditions.cancellationConditions',
							$event
						)
					"
					id="cancellationConditions"
					required
				>
				</b-form-textarea>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<b-form-group class="flex-checkbox-group">
				<label>Méthodes de paiment acceptés</label>
				<b-form-checkbox-group
					id="checkbox-payment-methods"
					v-model="conditions.accepted_payment_methods"
					:options="payment_methods"
					name="accepted_payment_methods"
					stacked
				></b-form-checkbox-group>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>Taxe de séjour</h3>
			<b-form-group
				label="Taxe de séjour"
				label-for="has_tourism_tax"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.has_tourism_tax"
					@input="$emit('update:conditions.has_tourism_tax', $event)"
					id="has_tourism_tax"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Montant taxe de séjour"
				v-if="conditions.has_tourism_tax"
				label-for="tourism_tax_amount"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="conditions.tourism_tax_amount"
						@input="
							$emit(
								'update:conditions.tourism_tax_amount',
								$event
							)
						"
						id="tourism_tax_amount"
						required
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>Wifi</h3>

			<b-form-group
				label="WIFI disponible"
				label-for="is_wifi_available"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.is_wifi_available"
					@input="
						$emit('update:conditions.is_wifi_available', $event)
					"
					id="is_wifi_available"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="WIFI gratuit"
				label-for="is_wifi_free"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.is_wifi_free"
					@input="$emit('update:conditions.is_wifi_free', $event)"
					id="is_wifi_free"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Supplément WIFI"
				v-show="!conditions.is_wifi_free"
				label-for="supplement_wifi"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="conditions.supplement_wifi"
						@input="
							$emit('update:conditions.supplement_wifi', $event)
						"
						id="supplement_wifi"
						required
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>Petit déjeuner</h3>

			<b-form-group
				label="Petit déjeuner disponible"
				label-for="is_breakfast_available"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.is_breakfast_available"
					@input="
						$emit(
							'update:conditions.is_breakfast_available',
							$event
						)
					"
					id="is_breakfast_available"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Tarif petit déjeuner"
				v-show="conditions.is_breakfast_available"
				label-for="breakfast_price"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="conditions.breakfast_price"
						@input="
							$emit('update:conditions.breakfast_price', $event)
						"
						id="breakfast_price"
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>

			<b-form-group
				label="Supplément petit déjeuner en chambre"
				v-show="conditions.is_breakfast_available"
				label-for="supplement_breakfast_in_room"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="conditions.supplement_breakfast_in_room"
						@input="
							$emit(
								'update:conditions.supplement_breakfast_in_room',
								$event
							)
						"
						id="supplement_breakfast_in_room"
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>

			<b-form-group
				label="Tarif réduit pour enfants"
				v-show="conditions.is_breakfast_available"
				label-for="has_reduced_breakfast_price_for_children"
				description=""
			>
				<b-form-checkbox
					v-model="
						conditions.has_reduced_breakfast_price_for_children
					"
					@input="
						$emit(
							'update:conditions.has_reduced_breakfast_price_for_children',
							$event
						)
					"
					id="has_reduced_breakfast_price_for_children"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Age maximum pour tarif réduit"
				v-show="
					conditions.is_breakfast_available &&
						conditions.has_reduced_breakfast_price_for_children
				"
				label-for="breakfast_price_reduced_for_children_max_age"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="
							conditions.breakfast_price_reduced_for_children_max_age
						"
						@input="
							$emit(
								'update:conditions.breakfast_price_reduced_for_children_max_age',
								$event
							)
						"
						id="breakfast_price_reduced_for_children_max_age"
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>

			<b-form-group
				label="Tarif réduit"
				v-show="
					conditions.is_breakfast_available &&
						conditions.has_reduced_breakfast_price_for_children
				"
				label-for="breakfast_price_reduced_for_children"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="
							conditions.breakfast_price_reduced_for_children
						"
						@input="
							$emit(
								'update:conditions.breakfast_price_reduced_for_children',
								$event
							)
						"
						id="breakfast_price_reduced_for_children"
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>Parking</h3>

			<b-form-group
				label="Parking sur place"
				label-for="parking_onsite"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.parking_onsite"
					@input="$emit('update:conditions.parking_onsite', $event)"
					id="parking_onsite"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Parking sur place sur réservation"
				v-show="conditions.parking_onsite"
				label-for="parking_obligatory_reservation"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.parking_obligatory_reservation"
					@input="
						$emit(
							'update:conditions.parking_obligatory_reservation',
							$event
						)
					"
					id="parking_obligatory_reservation"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Frais de parking"
				v-show="conditions.parking_onsite"
				label-for="parking_supplement"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="conditions.parking_supplement"
						@input="
							$emit(
								'update:conditions.parking_supplement',
								$event
							)
						"
						id="parking_supplement"
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>

			<b-form-group
				label="Informations supplémentaires pour le parking"
				label-for="parkingConditions"
				description=""
			>
				<b-form-textarea
					v-model="conditions.parkingConditions"
					@input="
						$emit('update:conditions.parkingConditions', $event)
					"
					id="parkingConditions"
					required
				>
				</b-form-textarea>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>Enfants</h3>
			<b-form-group
				label="Les enfants sont acceptés"
				label-for="children_accepted"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.children_accepted"
					@input="
						$emit('update:conditions.children_accepted', $event)
					"
					id="children_accepted"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Age max. enfant séjourant gratuitement dans la chambre des parents"
				label-for="max_age_child_free_stay"
				description=""
			>
				<b-form-input
					type="number"
					min="0"
					v-model="conditions.max_age_child_free_stay"
					@input="
						$emit(
							'update:conditions.max_age_child_free_stay',
							$event
						)
					"
					id="max_age_child_free_stay"
					required
				>
				</b-form-input>
			</b-form-group>

			<b-form-group
				label="Lit d'appoint disponible sur réservation"
				label-for="is_extra_bed_available"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.is_extra_bed_available"
					@input="
						$emit(
							'update:conditions.is_extra_bed_available',
							$event
						)
					"
					id="is_extra_bed_available"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				v-if="conditions.is_extra_bed_available"
				label="Supplément lit d'appoint"
				label-for="extra_bed_supplement"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="conditions.extra_bed_supplement"
						@input="
							$emit(
								'update:conditions.extra_bed_supplement',
								$event
							)
						"
						id="extra_bed_supplement"
						required
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>

			<b-form-group
				label="Lit bébé disponible sur réservation"
				label-for="is_baby_cot_available"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.is_baby_cot_available"
					@input="
						$emit('update:conditions.is_baby_cot_available', $event)
					"
					id="is_baby_cot_available"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				v-if="conditions.is_baby_cot_available"
				label="Supplément lit bébé"
				label-for="baby_cot_supplement"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="conditions.baby_cot_supplement"
						@input="
							$emit(
								'update:conditions.baby_cot_supplement',
								$event
							)
						"
						id="baby_cot_supplement"
						required
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>

			<b-form-group
				label="Informations supplémentaires pour les enfants"
				label-for="childrenConditions"
				description=""
			>
				<b-form-textarea
					v-model="conditions.childrenConditions"
					@input="
						$emit('update:conditions.childrenConditions', $event)
					"
					id="childrenConditions"
					required
				>
				</b-form-textarea>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>PMR</h3>

			<b-form-group
				label="L'établissement peut accueillir les personnes à mobilité réduite"
				label-for="has_adaptations_for_handicaps"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.has_adaptations_for_handicaps"
					@input="
						$emit(
							'update:conditions.has_adaptations_for_handicaps',
							$event
						)
					"
					id="has_adaptations_for_handicaps"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				label="Nbr. de chambres PMR"
				label-for="handicap_num_adapted_rooms"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="conditions.handicap_num_adapted_rooms"
						@input="
							$emit(
								'update:conditions.handicap_num_adapted_rooms',
								$event
							)
						"
						id="handicap_num_adapted_rooms"
						required
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>

			<b-form-group class="flex-checkbox-group">
				<label
					>Mon établissement est adapté pour l'accueil des personnes
					dans les situations d'handicape suivantes
				</label>
				<!-- 
				<div>
					<b-form-checkbox
						v-for="adaptation in available_handicap_adaptations"
						v-model="conditions.handicap_adaptations"
						:key="adaptation.value"
						:value="adaptation.value"
						name="handicap_adaptations"
					>
						{{ adaptation.text }}</b-form-checkbox
					>
				</div> -->
				<b-form-checkbox-group
					id="checkbox-handicap-adaptations"
					v-model="conditions.handicap_adaptations"
					:options="available_handicap_adaptations"
					name="handicap_adaptations"
					stacked
				></b-form-checkbox-group>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>Animaux</h3>

			<b-form-group
				label="Animaux de compagnie acceptés"
				label-for="animal_accepted"
				description=""
			>
				<b-form-checkbox
					v-model="conditions.animal_accepted"
					@input="$emit('update:conditions.animal_accepted', $event)"
					id="animal_accepted"
					name="check-button"
					size="lg"
					switch
				>
				</b-form-checkbox>
			</b-form-group>

			<b-form-group
				v-show="conditions.animal_accepted"
				label="Supplément animaux de compagnie"
				label-for="animal_supplement"
				description=""
			>
				<b-input-group append="€">
					<b-form-input
						type="number"
						step="any"
						min="0"
						v-model="conditions.animal_supplement"
						@input="
							$emit('update:conditions.animal_supplement', $event)
						"
						id="animal_supplement"
						required
					>
					</b-form-input>
				</b-input-group>
			</b-form-group>

			<b-form-group
				label="Informations supplémentaires pour les animaux"
				label-for="animalsConditions"
				description=""
			>
				<b-form-textarea
					v-model="conditions.animalsConditions"
					@input="
						$emit('update:conditions.animalsConditions', $event)
					"
					id="animalsConditions"
					required
				>
				</b-form-textarea>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<h3>Informations supplémentaires</h3>

			<b-form-group
				label="Informations supplémentaires"
				label-for="supplementary"
				description=""
			>
				<b-form-textarea
					v-model="conditions.supplementary"
					@input="$emit('update:conditions.supplementary', $event)"
					id="supplementary"
					required
				>
				</b-form-textarea>
			</b-form-group>
		</fieldset>
	</div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker';
export default {
	name: 'FormConditions',
	components: {
		VueTimepicker,
	},
	props: ['conditions', 'payment_methods', 'available_handicap_adaptations'],
};
</script>

<style lang="scss">
.datetime-picker {
	display: flex;
	justify-content: center;
	align-items: center;
}

.flex-checkbox-group > div {
	display: flex;
}
</style>
